import { Tiktoken } from 'js-tiktoken/lite';
import cl100k_base from 'js-tiktoken/ranks/cl100k_base';

type TokenCountInput = string | null | undefined;

let cachedEncoder: Tiktoken | undefined;

export function countTokens(input: TokenCountInput | TokenCountInput[]): number {
  const inputs = Array.isArray(input) ? input : [input];
  const validInputs = inputs.filter((text): text is string => !!text && typeof text === 'string');

  if (!validInputs.length) {
    return 0;
  }

  const encoder = getEncoder();
  let total = 0;

  for (const text of validInputs) {
    total += encoder.encode(text).length;
  }

  return total;
}

function getEncoder() {
  if (!cachedEncoder) {
    // Encoder construction is measured to take 80-120ms, so we cache the result
    cachedEncoder = new Tiktoken(cl100k_base);
  }

  return cachedEncoder;
}
